import {FormControl, FormGroup} from '@angular/forms';

import {BaseControl} from '../../../shared/classes';

import {PanelAccountsEditAccountControls} from '../../../../assets/descriptors';

export class EditTradingAccountForm {
    public form: FormGroup;
    public controls: BaseControl[];

    constructor() {
        this.controls = [];
    }

    initForm(): void {
        this.form = new FormGroup({});

        this.controls = PanelAccountsEditAccountControls().map((control: BaseControl) => {
            this.form.addControl(control.name, new FormControl(control.value, control.validators));

            return control;
        });
    }


}
